// extracted by mini-css-extract-plugin
export default {"actions":"L1h34","adminLink":"W+652","adminLinkText":"M9CgL","editMode":"_9U5o-"};